export enum OrderPaymentStatus {
	PENDING = "PENDIENTE",
	PARTIAL = "PARCIAL",
	PAID = "PAGADO",
}
